export default class ShopMenuButton extends HTMLElement {
  open: boolean = false
  buttonEl: HTMLElement | null = null

  constructor() {
    super()

    this.buttonEl = this.querySelector<HTMLElement>('button[data-menu-button]') as HTMLElement

    if (this.buttonEl) {
      this.buttonEl.addEventListener('click', this.handleClick.bind(this))
    }

    (window as any).addEventListener('menu:toggle', this.handleMenu.bind(this))
  }

  get isOpen() {
    return this.open
  }

  set isOpen(value: boolean) {
    this.open = value
  }

  handleClick(evt: Event) {
    evt.preventDefault()

    console.log('Menu button clicked')

    window.dispatchEvent(new CustomEvent('menu:toggle', { bubbles: true, detail: { open: !this.isOpen } }))
  }

  handleMenu(evt: CustomEvent) {
    // @ts-ignore
    this.isOpen = evt.detail.open

    console.log('Menu button handleMenu', this.isOpen)
  }

  connectedCallback() {
    console.log('Menu button added')
  }
}

customElements.define('shop-menu-button', ShopMenuButton)
